<script setup lang="ts">
    import IconButton from '@/js/components/IconButton.vue';
    import { ArrowUpIcon, ArrowDownIcon } from '@lucide/vue';

    defineProps<{
        ascDisabled: boolean;
        descDisabled: boolean;
    }>();

    const emit = defineEmits<{ sort: [direction: 'asc' | 'desc'] }>();
</script>
<template>
    <span class="flex">
        <IconButton area-size="size-4" size="size-3" :disabled="ascDisabled" @click="emit('sort', 'asc')">
            <ArrowUpIcon class="size-3" />
        </IconButton>
        <IconButton area-size="size-4" size="size-3" :disabled="descDisabled" @click="emit('sort', 'desc')">
            <ArrowDownIcon class="size-3" />
        </IconButton>
    </span>
</template>
